import React from 'react';
import { Input, Typography } from 'antd';
import { PhoneOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { validateExtension } from '../utils/sipuniApi';
import './SipuniExtension.css';

const { Text } = Typography;

/**
 * Компонент для выбора внутреннего номера Sipuni
 */
const SipuniExtensionField = ({ 
  value, 
  onChange, 
  disabled = false,
  required = false 
}) => {
  // Валидация введенного номера
  const validation = value ? validateExtension(value) : { isValid: true, errors: [] };

  return (
    <div className="sipuni-extension-field">
      <div className="field-header">
        <Text strong>
          <PhoneOutlined className="help-icon" />
          Внутренний номер Sipuni {required && <span className="required-mark">*</span>}
        </Text>
      </div>

      {/* Основное поле ввода */}
      <Input
        value={value}
        onChange={(e) => {
          const inputValue = e.target.value;
          // Разрешаем только цифры и ограничиваем до 4 символов
          const digitsOnly = inputValue.replace(/\D/g, '').slice(0, 4);
          onChange(digitsOnly);
        }}
        disabled={disabled}
        placeholder="Введите внутренний номер (например: 101, 208)"
        style={{ width: '100%' }}
        maxLength={4}
        prefix={<PhoneOutlined style={{ color: '#1890ff' }} />}
        suffix={
          value && validation.isValid ? (
            <CheckCircleOutlined style={{ color: '#52c41a' }} />
          ) : null
        }
      />

      {/* Справочная информация */}
      <div className="field-help">
        <Text type="secondary" className="help-text">
          💡 <strong>Что это:</strong> Внутренний номер в системе телефонии Sipuni (например: 101, 208, 210).
          Позволяет автоматически связывать звонки с аккаунтом пользователя.
        </Text>
        
        <Text type="secondary" className="help-text" style={{ display: 'block', marginTop: '4px' }}>
          📝 Введите 3-4 цифры (только числа).
        </Text>
        
        {value && validation.isValid && (
          <Text type="success" className="help-success">
            <CheckCircleOutlined className="help-icon" />
            Номер {value} будет привязан к аккаунту
          </Text>
        )}
        
        {value && !validation.isValid && (
          <div>
            {validation.errors.map((errorMsg, index) => (
              <Text key={index} type="danger" className="help-error" style={{ display: 'block' }}>
                ⚠️ {errorMsg}
              </Text>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SipuniExtensionField;
